/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Nav_AriaInputs */

const en_directory_footer_nav_aria = /** @type {(inputs: Directory_Footer_Nav_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Footer navigation`)
};

const zh_directory_footer_nav_aria = /** @type {(inputs: Directory_Footer_Nav_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`页脚导航`)
};

/**
* | output |
* | --- |
* | "Footer navigation" |
*
* @param {Directory_Footer_Nav_AriaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_nav_aria = /** @type {((inputs?: Directory_Footer_Nav_AriaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Nav_AriaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_nav_aria(inputs)
	return zh_directory_footer_nav_aria(inputs)
});
export { directory_footer_nav_aria as "directory.footer.nav_aria" }